const sortValue = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map(sortValue);
  }

  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.keys(value as Record<string, unknown>)
        .sort()
        .map(key => [key, sortValue((value as Record<string, unknown>)[key])])
    );
  }

  return value;
};

export const buildApiCacheKey = (
  cacheNamespace: string,
  operationName: string,
  variables: Record<string, unknown> = {}
): string => `${cacheNamespace}:${operationName}:${JSON.stringify(sortValue(variables))}`;
